export default "__VITE_ASSET__CV5JtqFL__"